/** Hotkeys we care about when interacting with a dropdown */
export var DropdownHotkey;
(function (DropdownHotkey) {
    DropdownHotkey["ARROW_UP"] = "arrow_up";
    DropdownHotkey["ARROW_DOWN"] = "arrow_down";
    DropdownHotkey["HOME"] = "home";
    DropdownHotkey["END"] = "end";
    DropdownHotkey["ENTER"] = "enter";
    DropdownHotkey["ESCAPE"] = "escape";
    DropdownHotkey["TAB"] = "tab";
    DropdownHotkey["SPACE"] = "space";
    DropdownHotkey["SEARCH"] = "search";
    DropdownHotkey["UNSUPPORTED"] = "unsupported";
})(DropdownHotkey || (DropdownHotkey = {}));
export function keyEventToHotkey(e) {
    switch (e.key) {
        case ' ':
        case 'Space':
            return DropdownHotkey.SPACE;
        case 'Enter':
            return DropdownHotkey.ENTER;
        case 'Escape':
            return DropdownHotkey.ESCAPE;
        case 'Tab':
            return DropdownHotkey.TAB;
        case 'ArrowDown':
            return DropdownHotkey.ARROW_DOWN;
        case 'ArrowUp':
            return DropdownHotkey.ARROW_UP;
        case 'Home':
            return DropdownHotkey.HOME;
        case 'End':
            return DropdownHotkey.END;
        default:
            if (e.key.match(/^[a-zA-Z0-9]$/)) {
                return DropdownHotkey.SEARCH;
            }
            return DropdownHotkey.UNSUPPORTED;
    }
}
//# sourceMappingURL=hotkeys.js.map